import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { useParams } from "react-router-dom";
import { useOpinionQuery } from "components/Opinion/OpinionCol/OpinionCol.hooks";
import ContentLoader from "react-content-loader";
import { ArticleContent } from "components/Article/ArticleContent";
import { ArticleFooter } from "components/Article/ArticleFooter/ArticleFooter";
import { ArticleHeader } from "components/Article/ArticleHeader";
import { UserContext } from "components/UserContext";
import { useContext } from "react";
import classNames from "classnames";
import { OpinionInduceRows } from "components/Opinion/OpinionInduceRows";

export const ArticlePage = () => {
  const { id } = useParams();
  const { isLoading, data: article } = useOpinionQuery({ id: id as string });
  const {isLoading: isLoadingUser, user } = useContext(UserContext);
  const canRead = user ? user.canReadArticles : false;

  return (
    <Container>
      {!isLoadingUser && !canRead && <OpinionInduceRows />}
      <Row>
        <Col>
          {isLoading && (
            <ContentLoader viewBox={`0 0 1296 620`}>
              <rect x={0} y={0} rx={4} ry={4} width={200} height={40} />
              <rect x={0} y={60} rx={4} ry={4} width={1296} height={500} />
              <rect x={0} y={580} rx={4} ry={4} width={1296} height={40} />
            </ContentLoader>
          )}
          {!isLoading && !article && (
            `잘못된 ID입니다. ${id}`
          )}
          {!isLoading && article && (
            <div className={classNames({ blur: !canRead })}>
              <ArticleHeader {...article} />
              <ArticleContent {...article} />
              <ArticleFooter {...article} />
            </div>
          )}
        </Col>
      </Row>
    </Container>
  );
};
